<template>
  <div class="p-[24px] rounded-lg border-[1px] border-[#e2e2e2] mb-[24px] container">
    <div class="flex items-center justify-between flex-wrap gap-10 mb-[24px]">
      <h3 class="text-[16px] font-semibold text-[#333333]">
        Partner dengan Kemungkinan Low Moving Stock
      </h3>
      <div class="flex items-center justify-end gap-[10px] flex-wrap">
        <div class="d-flex rounded-lg align-items-center text-[#c2c2c2] px-[12px] py-[3px] border-[1px] border-[#e2e2e2] w-full sm:w-auto">
          <span
            class="k-search-normal-1 font-bold text-[24px] align-middle mx-[5px]"
          />
          <BFormInput
            v-model="mitra_name"
            placeholder="Cari nama mitra"
            class="w-100 border-0 focus:!shadow-none !rounded-r-lg !text-[14px]"
            debounce="1000"
          />
        </div>
        <b-form-select
          v-model="period"
          :options="optionDateRangeLowMovingStock"
          class="csd !w-auto !border-[#e2e2e2] !text-[14px] !font-[500] !text-[#C2C2C2]"
        />
        <!-- <date-picker v-model="period" /> -->
        <b-button
          variant="primary"
          class="!flex items-center justify-center gap-5 inline-block !text-[14px] !font-[600] !rounded-lg w-full sm:w-auto"
          :disbaled="loadingExportData"
          @click="exportData"
        >
          <b-spinner
            v-if="loadingExportData"
            small
          />
          Export Data
        </b-button>
      </div>
    </div>
    <BOverlay
      :show="loadingTable"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <BTable
        :items="lowMovingData"
        :fields="lowMovingStockFields"
        show-empty
        empty-text="Tidak ada data yang ditampilkan."
        responsive
        sticky-header="725px"
      >
        <template #head(unsold_quantity)="data">
          <div class="flex items-center gap-10 flex-wrap">
            {{ data.label }}<img
              id="lms-qty-info"
              class="w-[20px] h-[20px]"
              src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
              alt="info"
            >
            <BPopover
              target="lms-qty-info"
              triggers="hover"
              placement="bottomleft"
            >Jumlah barang yang terkena low moving stock</BPopover>
          </div>
        </template>
        <template #cell(partner_contact)="data">
          <div class="flex items-center gap-[4px]">
            <span class="k-Whatsapp text-[24px] text-[#10673E]" />
            <a
              :href="`https://wa.me/${data.value}`"
              target="_blank"
              class="text-[#10673E] underline hover:text-[#333333] hover:undeline transition"
            >{{ data.value }}</a>
          </div>
        </template>
      </BTable>
      <div
        v-if="lowMovingData.length > 0"
        class="text-center"
      >
        <router-link
          to="/kompack-partner-low-moving-stock"
          class="text-[12px] font-medium p-[16px] pt-0 text-[#08A0F7] hover:text-[#08A0F7] hover:underline"
        >Lihat selengkapnya</router-link>
      </div>
    </BOverlay>
  </div>
</template>

<script>
import { DAY_MONTH_YEAR } from '@/libs/filterDate'
import { downloadFileFromBlob } from '@/libs/downloadFile'
import { locale, ranges } from '../config'
import { getFormattedDateRange } from '../helpers'
import { lowMovingStockFields, optionDateRangeLowMovingStock } from './partner-low-moving-stock/config'

export default {
  data() {
    return {
      loadingExportData: false,
      loadingTable: false,
      mitra_name: '',
      period: 'this_month',
      DAY_MONTH_YEAR,
      optionDateRangeLowMovingStock,
      locale,
      ranges,
      lowMovingStockFields,
      lowMovingData: [
        {
          partner_name: 'Dwi Ilham',
          warehouse_name: 'Indo Jaya Putra',
          partner_contact: '082121433085',
          qty: 16,
          low_moving_cost: 40000000,
        },
        {
          partner_name: 'Dwi Ilham',
          warehouse_name: 'Indo Jaya Putra',
          partner_contact: '082121433085',
          qty: 16,
          low_moving_cost: 40000000,
        },
      ],
    }
  },
  watch: {
    period() {
      this.getLowMovingStockData()
    },
    mitra_name() {
      this.getLowMovingStockData()
    },
  },
  created() {
    this.getLowMovingStockData()
  },
  methods: {
    getFormattedDateRange,
    /**
     * Fetches low moving stock data from API based on period and search filters
     */
    getLowMovingStockData() {
      this.loadingTable = true
      const url = '/kompack/api/v1/dashboard/stock-recaps/alert-low-moving-stock'
      const params = {
        month: this.period,
        search: this.mitra_name,
        limit: 10,
        offset: 0,
      }
      this.$http_new.get(url, { params })
        .then(res => {
          const { data } = res.data
          this.lowMovingData = data ?? []
        })
        .catch(err => {
          this.$toast_error({ message: 'Gagal mengambil data, silahkan coba lagi.' })
        })
        .finally(() => {
          this.loadingTable = false
        })
    },

    /**
     * Exports low moving stock data to Excel file
     */
    exportData() {
      this.loadingExportData = true
      this.$http_new.post('/kompack/api/v1/dashboard/stock-recaps/alert-low-moving-stock/export-data', null, {
        params: {
          search: this.mitra_name,
          month: this.period,
        },
        responseType: 'blob',
      }).then(res => {
        if (!res.data) {
          throw new Error('no data')
        }
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        downloadFileFromBlob(blob, `partner_low_moving_stock_${this.period}.xlsx`)
        this.$toast_success({ message: 'Berhasil mengunduh file.' })
      }).catch(_err => {
        if (_err.response.data.message) {
          this.$toast_error({ message: 'Tidak ada data yang dapat diunduh.' })
        } else {
          this.$toast_error({ message: 'Gagal mengunduh file, silahkan coba lagi.' })
        }
      }).finally(() => {
        this.loadingExportData = false
      })
    },
  },
}
</script>

<style scoped>
.container::v-deep td {
    padding: 12px 16px;
    color: #333333;
}
.csd {
  background-image: url('https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/calendar.svg');
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 50px;
}
</style>
